module.exports = __webpack_public_path__ + "assets/logo-twolines-right-white-fr.2f4d536b.svg";